export default __webpack_public_path__ + "static/media/bg.a7cadbf5.jpg";